<template>
  <div class="tagGroup" @click="clicked($event)">
    <span class="name">{{ node.data.name }}</span>
    <el-dropdown
      id="dropdownForTour"
      slot="dropdown"
      class="control-group tree-point-options"
      trigger="click"
      @command="handleCommand"
    >
      <span class="el-dropdown-link">
        <em class="el-icon-more"></em>
      </span>
      <el-dropdown-menu slot="dropdown" :placement="'top'">
        <el-dropdown-item
          v-if="checkPermission('updatePoint') && node.data._id != 'root'"
          command="editGroup"
          >{{ $t("tree.edit") }}</el-dropdown-item
        >
        <el-dropdown-item
          v-if="checkPermission('createPoint') && node.data._id != 'root'"
          command="createPoint"
          id="vueTourCreatePoint"
          :disabled="hasGroup"
          >{{ $t("tree.createpoint") }}</el-dropdown-item
        >
        <el-dropdown-item
          command="createGroup"
          data-v-step="createGroupButton"
          :disabled="hasPoint"
          >{{ $t("tree.createGroup") }}</el-dropdown-item
        >
        <el-dropdown-item
          v-if="checkPermission('deletePoint') && node.data._id != 'root'"
          command="delete"
          divided
          :disabled="node.data.children && node.data.children.length != 0"
          >{{ $t("tree.delete") }}</el-dropdown-item
        >
      </el-dropdown-menu>
    </el-dropdown>

    <el-dialog
      width="80%"
      :title="$t('tree.createpoint')"
      :visible.sync="showCreatePoint"
    >
      <CreatePoint
        :parentGroupId="node.data._id"
        v-on:created="pointCreated"
        v-on:cancelled="createPointCancelled"
      ></CreatePoint>
    </el-dialog>

    <el-dialog
      width="30%"
      :title="$t('tree.createGroup')"
      :visible.sync="showCreateGroup"
    >
      <CreateGroup
        :parentGroupId="node.data._id"
        v-on:created="groupCreated"
        v-on:cancelled="createGroupCancelled"
      ></CreateGroup>
    </el-dialog>

    <el-dialog
      width="30%"
      :title="$t('tree.editgroup')"
      :visible.sync="showEditGroup"
    >
      <EditGroup
        :id="node.data._id"
        v-on:updated="updated"
        v-on:cancelled="editGroupCancelled"
      ></EditGroup>
    </el-dialog>
    <!-- <a href="#" @click="clicked($event)">test</a> -->
  </div>
</template>
<script>
import CreatePoint from "./CreatePoint";
import CreateGroup from "./CreateGroup";
import EditGroup from "./EditGroup";
import axios from "axios";

export default {
  name: "Group",
  components: { CreateGroup, EditGroup, CreatePoint },
  events: ["groupDeleted", "groupUpdated", "groupCreated", "pointCreated"],
  props: ["node"],
  data() {
    return {
      showCreateGroup: false,
      showEditGroup: false,
      showCreatePoint: false,
    };
  },
  created() {},
  methods: {
    clicked() {
      //event.stopPropagation();
    },
    createPointCancelled() {
      this.showCreatePoint = false;
    },
    editGroupCancelled() {
      this.showEditGroup = false;
    },
    createGroupCancelled() {
      this.showCreateGroup = false;
    },
    updated(data) {
      this.showEditGroup = false;
      this.$emit("groupUpdated", this.node, data);
    },
    pointCreated(data) {
      this.showCreatePoint = false;
      this.$emit("pointCreated", this.node, data);
    },
    groupCreated(data) {
      this.$emit("groupCreated", this.node, data);
      this.showCreateGroup = false;
    },
    handleCommand(command) {
      switch (command) {
        case "createGroup":
          this.showCreateGroup = true;
          break;
        case "editGroup":
          this.showEditGroup = true;
          break;
        case "createPoint":
          this.showCreatePoint = true;
          break;
        case "delete":
          this.$confirm(
            this.$t("tree.warningtextgroup"),
            this.$t("tree.warning"),
            {
              confirmButtonText: this.$t("tree.warningConfirmText"),
              cancelButtonText: this.$t("tree.warningCancelText"),
              type: "warning",
            }
          )
            .then(async () => {
              return axios.delete(
                `${process.env.VUE_APP_APIURL}/tree/group/${this.node.data._id}`
              );
            })
            .then(() => {
              this.$emit("groupDeleted", this.node);
              this.$message({
                type: "success",
                message: this.$t("tree.deleteCompleted"),
              });
            })
            .catch((e) => {
              this.$message({
                type: "info",
                message: e.response.data.message,
              });
            });
          break;
      }
    },
  },
  computed: {
    hasGroup() {
      return this.node.data.children.some((data) => data.nodeType == "group");
    },
    hasPoint() {
      return this.node.data.children.some((data) => data.nodeType == "point");
    },
  },
};
</script>
<style scoped>
</style>